import React from "react";

export const DataContext = React.createContext({
  id: null,
  name: "",
  email: "",
  phone_number: "",
  password: null,
  photo: null,
});
